// Curated catalog intentionally EMPTY (2026-07-12): the site now runs purely on
// the SeatGeek "most wanted" feed generated into live.ts at build time.
// This file remains as the merge point for future hand-curated marquee events.
import type { RawEvent } from '../types';

export const RAW_EVENTS: RawEvent[] = [];
